// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BarChartBlock_charts_view__skbzF {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.BarChartBlock_chart__xD24x {
  margin-top: 3%;
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 3px 15px;
}

.BarChartBlock_chart_title__YItHl {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.BarChartBlock_chart_title_filter__owkLw {
  width: 30%;
}

.BarChartBlock_chart_currency_filter__cQGsx {
  width: 15%;
}

.BarChartBlock_custom_tooltip__pRPCl {
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 10px;
  max-height: 300px;
  overflow: scroll;
  pointer-events: all !important;
}

.BarChartBlock_custom_tooltip_label__V9Ls- {
  margin-top: 0 !important;
  margin-bottom: 3px !important;
}

.BarChartBlock_tooltip_entry__gkG4n {
  margin-top: 2px !important;
  margin-bottom: 0 !important;
}

.BarChartBlock_custom_tooltip_total__yneCy {
  font-style: oblique;
  margin-top: 3px !important;
  margin-bottom: 0 !important;
}

.BarChartBlock_year_label__BX6Es {
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/BarChart/BarChartBlock.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".charts_view {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n}\n.chart {\n  margin-top: 3%;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  padding: 3px 15px;\n}\n\n.chart_title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.chart_title_filter {\n  width: 30%;\n}\n\n.chart_currency_filter {\n  width: 15%;\n}\n\n.custom_tooltip {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  padding: 10px;\n  max-height: 300px;\n  overflow: scroll;\n  pointer-events: all !important;\n}\n\n.custom_tooltip_label {\n  margin-top: 0 !important;\n  margin-bottom: 3px !important;\n}\n\n.tooltip_entry {\n  margin-top: 2px !important;\n  margin-bottom: 0 !important;\n}\n\n.custom_tooltip_total {\n  font-style: oblique;\n  margin-top: 3px !important;\n  margin-bottom: 0 !important;\n}\n\n.year_label {\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"charts_view": `BarChartBlock_charts_view__skbzF`,
	"chart": `BarChartBlock_chart__xD24x`,
	"chart_title": `BarChartBlock_chart_title__YItHl`,
	"chart_title_filter": `BarChartBlock_chart_title_filter__owkLw`,
	"chart_currency_filter": `BarChartBlock_chart_currency_filter__cQGsx`,
	"custom_tooltip": `BarChartBlock_custom_tooltip__pRPCl`,
	"custom_tooltip_label": `BarChartBlock_custom_tooltip_label__V9Ls-`,
	"tooltip_entry": `BarChartBlock_tooltip_entry__gkG4n`,
	"custom_tooltip_total": `BarChartBlock_custom_tooltip_total__yneCy`,
	"year_label": `BarChartBlock_year_label__BX6Es`
};
export default ___CSS_LOADER_EXPORT___;
